import type { OHLCV } from '@shared/types/candle'

import { registerIndicator } from '@/indicators/registry'
import type { IndicatorConfig, IndicatorResult } from '@/types/indicator'
import { IndicatorBase } from '@/types/indicator'

const CONFIG: IndicatorConfig = {
  id: 'obv',
  name: 'On-Balance Volume',
  shortName: 'OBV',
  category: 'volume',
  overlay: false,
  params: [],
  lines: [{ key: 'obv', label: 'OBV', color: '#00bcd4', width: 1 }],
  // Unbounded — no priceRange; scale auto-fits
}

class OBV extends IndicatorBase {
  readonly config = CONFIG

  calculate(candles: OHLCV[], _params: Record<string, number | string | boolean>): IndicatorResult {
    const values: (number | null)[] = new Array<number | null>(candles.length).fill(null)
    let obv = 0

    for (let i = 0; i < candles.length; i++) {
      if (i === 0) {
        obv = candles[i].v
      } else {
        if (candles[i].c > candles[i - 1].c) obv += candles[i].v
        else if (candles[i].c < candles[i - 1].c) obv -= candles[i].v
        // equal close → obv unchanged
      }
      values[i] = obv
    }

    return { lines: [{ key: 'obv', values }] }
  }
}

registerIndicator(OBV, CONFIG)
